export default {
  l_Order_tasks: "Задачи по заказам",
  l_Task: "Задача",
  l_Kind: "Тип",
  l_Contact_client: "Связь с клиентом",
  l_Document_collection: "Сбор документов",
  l_Not_started: "Не начата",
  l_In_progress: "В работе",
  l_Completed: "Завершена",
  l_Document_collector: "Способ сбора",
  l_Self: "Сам",
  l_Broker: "Брокер",
  l_Assignee: "Исполнитель",
  l_Deadline: "Срок",
  l_By_orders: "По заказам",
  l_List_view: "Список",
  l_Filters: "Фильтры",
  l_Add_task: "Добавить задачу",
  "p_comments:delete": "Комментарии: Удаление",
  "p_comments:edit": "Комментарии: Редактирование",
  "p_comments:create": "Комментарии: Создание",
  "p_comments:view": "Комментарии: Просмотр",
  "p_price+proposals+++delete": "Предложения по цене: Удаление",
  "p_price+proposals+++edit": "Предложения по цене: Редактирование",
  "p_price+proposals+++create": "Предложения по цене: Создание",
  "p_price+proposals+++view": "Предложения по цене: Просмотр",
  "p_change+protected+statuses": "Изменение защищенных статусов",
  "p__request+rate": "Запросы на цену",
  "p_delete+requests": "Удаление запросов",
  "p_editing+requests": "Редактирование запросов",
  "p_create+requests": "Чтение запросов",
  "p_view+requests": "Просмотр запросов",
  "p_edit+contact": "Контакты: Редактирование",
  "p_change+credit+limit": "Кредитный лимит: Изменение",
  "p_delete+clients": "Клиенты: Удаление",
  "p_editing+clients": "Клиенты: Редактирование",
  "p_create+clients": "Клиенты: Создание",
  "p_view+clients": "Клиенты: Просмотр",
  "p_delete+carriers": "Перевозчики: Удаление",
  "p_editing+carriers": "Перевозчики: Редактирование",
  "p_create+carriers": "Перевозчики: Создание",
  "p_view+carriers": "Перевозчики: Просмотр",
  "p_documents(transportation,+cmr,+photo):+view":
    "Документы (транспортировка, CMR, фото): Просмотр",

  "p_other:+view": "Прочее: Просмотр",
  "p_act:+view": "Акт: Просмотр",

  "p_other:+create": "Прочее: Создание",
  "p_other:+delete": "Прочее: Удаление",
  "p_other:+edit": "Прочее: Редактирование",

  "p_acts:+create": "Акты: Создание",
  "p_acts:+delete": "Акты: Удаление",
  "p_acts:+edit": "Акты: Редактирование",

  "p_comments+create": "Комментарии: Создание",
  "p_comments+edit": "Комментарии: Редактирование",
  "p_comments+delete": "Комментарии: Удаление",
  "p_comments+view": "Комментарии: Просмотр",

  "p_view+order+tasks": "Задачи по заказам: Просмотр",
  "p_create+order+tasks": "Задачи по заказам: Создание",
  "p_editing+order+tasks": "Задачи по заказам: Редактирование",
  "p_delete+order+tasks": "Задачи по заказам: Удаление",
  "p_all+order+tasks": "Задачи по заказам: Все",

  "p_edit+paid+invoices": "Оплаченные счета: Редактирование",

  p_delete: "Удаление",
  p_edit: "Редактирование",
  p_create: "Создание",
  p_view: "Просмотр",

  "p_edit+paid+invoices_2": "Оплаченные счета: Редактирование",
  p_delete_2: "Удаление",
  p_edit_2: "Редактирование",
  p_create_2: "Создание",
  p_view_2: "Просмотр",

  "p_edit+order+status+history": "История статусов заказа: Редактирование",
  "p_view+order+status+history": "История статусов заказа: Просмотр",

  "p_delete+financial": "Финансы: Удаление",
  "p_edit+financial": "Финансы: Редактирование",
  "p_view+financial": "Финансы: Просмотр",

  "p_edit+freight": "Фрахт: Редактирование",
  "p_view+freight": "Фрахт: Просмотр",

  p_margin: "Маржа",
  p_total: "Итого",

  "p_trips+in+order": "Рейсы в заказе",

  "p_documents(transportation,+cmr,+phtoto)":
    "Документы (транспортировка, CMR, фото)",

  "p_cargo+information": "Информация о грузе",
  "p_client+information": "Информация о клиенте",

  p_profit: "Прибыль",

  "p_delete+orders": "Заказы: Удаление",
  "p_edit+status": "Статус: Редактирование",
  "p_editing+orders": "Заказы: Редактирование",
  "p_create+orders": "Заказы: Создание",
  "p_view+orders": "Заказы: Просмотр",

  "p_delete+trips": "Рейсы: Удаление",
  "p_update+trips": "Рейсы: Обновление",
  "p_create+trips": "Рейсы: Создание",
  "p_trips+view": "Рейсы: Просмотр",

  "p_your+own+departments+orders": "Заказы своего отдела",
  "p_your+own+orders": "Свои Заказы",
  "p_all+orders": "Все Заказы",

  "p_your+own+departments+requests": "Запросы своего отдела",
  "p_your+own+requests": "Свои Запросы",
  "p_all+requests": "Все Запросы",

  "p_your+own+departments+clients": "Клиенты своего отдела",
  "p_your+own+clients": "Свои Клиенты",
  "p_all+clients": "Все Клиенты",

  "p_your+own+departments+carriers": "Перевозчики своего отдела",
  "p_your+own+carriers": "Свои Перевозчики",
  "p_all+carriers": "Все Перевозчики",

  "p_your+own+departments+trips": "Рейсы своего отдела",
  "p_your+own+trips": "Свои Рейсы",
  "p_all+trips": "Все Рейсы",

  "p_view+additional+expenses": "Cебестоимость: Просмотр",
  "p_create+additional+expenses": "Cебестоимость: Создание",
  "p_update+additional+expenses": "Cебестоимость: Изменение",
  "p_delete+additional+expenses": "Cебестоимость: Удаление",
  "p_your+own+additional+expenses": "Свои себестоимостьы",
  "p_all+additional+expenses": "Все себестоимостьы",
  "p_your+own+departments+additional+expenses": "Cебестоимость своего отдела",

  l_Username: "Имя пользователя",
  l_User_password: "Пароль",
  l_Forgot_password: "Восстановить пароль",
  l_Forgot_password_title: "Восстановление пароля",
  l_Enter_email: "Введите ваш email",
  l_Send_reset_link: "Отправить ссылку",
  l_Back_to_login: "Вернуться к входу",
  l_Reset_link_sent: "Код повторно отправлен",
  l_Check_email_desc:
    "Если email существует, инструкции по восстановлению пароля отправлены на вашу почту.",
  l_Code_sent_hint: "Код отправлен на почту",
  l_Enter_code: "Введите код из письма",
  l_Verify_code: "Подтвердить",
  l_Resend_code: "Отправить снова",
  l_Back: "Назад",
  l_New_password: "Новый пароль",
  l_Confirm_new_password: "Подтвердите новый пароль",
  l_Reset_password: "Сбросить пароль",
  l_Passwords_not_match: "Пароли не совпадают",
  l_Password_reset_success: "Пароль успешно изменён",
  l_Token_invalid: "Ссылка недействительна или истекла",
  l_Verifying_token: "Проверка ссылки...",
  l_Step_email: "Email",
  l_Step_code: "Код",
  l_Step_password: "Пароль",
  l_Login: "Войти",
  l_Sign_out: "Выход",
  l_EmailorPasswordisWrong: "Электронная почта или пароль неверны",
  l_Requests: "Запросы",
  l_Orders: "Заказы",
  l_Finance: "Финансы",
  l_Clients: "Клиенты",
  l_Carriers: "Перевозчики",
  l_Settings: "Параметры",
  l_Organization: "Организация",
  l_Templates: "Шаблоны",
  l_Classifiers: "Справочники",
  l_System: "Система",
  l_Log: "Логи",
  l_Add_places: "Перенести маршрут из груза",
  l_Change_password: "Поменять пароль",
  l_New_rail_station: "Новая ЖД станция",
  l_Station: "ЖД станция",
  l_Rail_stations: "ЖД станции",
  l_Companies: "Компании",
  l_Client_to_user: "Доступ для клиентов",
  l_Carrier_to_user: "Доступ для перевозчиков",
  l_Departments: "Отделы",
  l_Give_access_to_client: "Предоставить доступ клиенту",
  l_Employees: "Сотрудники",
  l_Groups_of_employees: "Группы сотрудников",
  l_Business_number: "Номер типа",
  l_Company_name: "Название компании",
  l_Name_in_original: "Название на языке оригинала",
  l_Company_code: "Код компании",
  l_VAT_code: "Код НДС",
  l_Cargo_information: "Информация о грузе",
  l_Address: "Адрес",
  l_Failed_to_submit: "Ошибка при загрузке",
  l_Address_for_correspondence: "Адрес для корреспонденции",
  l_Banks: "Банки",
  l_Calculations: "Расчеты",
  l_Cargo_statuses: "Статусы грузов",
  l_Client_types: "Типы клиентов",
  l_Provide_access_to_carrier: "Предоставить доступ перевозчику",
  l_Document_statuses: "Статусы документов",
  l_Order_statuses: "Статусы заказов",
  l_Railway_stations: "Железнодорожные станции",
  l_Transport_types: "Типы транспорта",
  l_Trip_statuses: "Статусы рейсов",
  l_VAT_rates: "Тарифы НДС",
  l_Workers_posts: "Должности сотрудников",
  l_Whatsapp_notification_send: "Отправка уведомления по WhatsApp",
  l_Name: "Название",
  l_Unofficial_name: "Название неофициальное",
  l_Branch: "Филиал",
  l_Code__: "МФО (БИК, BLZ)",
  l_Post_code: "Почтовый код",
  l_LanguageSettings: "Настройки языка",
  l_SystemLogs: "Системные логи",
  l_Notifications: "Уведомления",
  l_Preferences: "Предпочтения",
  l_ExportData: "Экспорт данных",
  l_DataPrivacy: "Конфиденциальность данных",
  l_TermsAndConditions: "Условия и положения",
  l_Help: "Помощь",
  l_FAQ: "Часто задаваемые вопросы",
  l_ChangePassword: "Изменить пароль",
  l_Other_docs: "Другие документы",
  l_Transportation_orders: "Заявки",
  l_Overhead_docs: "Накладные",
  l_Request_doc: "Документы из запроса",
  l_Backup: "Резервное копирование",
  l_AdvancedSettings: "Расширенные настройки",
  l_Support: "Поддержка",
  l_PrivacyPolicy: "Политика конфиденциальности",
  l_Subscription: "Подписка",
  l_LanguagePreference: "Предпочтение языка",
  l_TimeZone: "Часовой пояс",
  l_Export_to_excel: "Excel",
  l_UserProfile: "Профиль пользователя",
  l_Change_group_cargo_status: "Изменить статус грузов (группа)",
  l_EmailPreferences: "Настройки электронной почты",
  l_Feedback: "Обратная связь",
  l_Action: "Действие",
  l_Add: "Добавить",
  l_Shipment: "Отгрузки",
  l_Transportation: "Заявки",
  l_Price_and_payment_term: "цена и условия оплаты",
  l_Issued_invoice: "Выписанные счета",
  l_Overhead: "Накладные",
  l_Freezing_order: "Заморозка заказа",
  l_Additional_expenses: "Cебестоимость",
  l_Trip_costs: "Расходы рейсов",
  l_Unrecorded_expenses: "Неучтенные расходы",
  l_Update: "Обновить",
  l_Edit: "Редактировать",
  l_Submit: "Отправить",
  l_Cancel: "Отменить",
  l_Are_you_sure_delete_this_task: "Вы уверены, что хотите удалить эту задачу?",
  l_Yes: "Да",
  l_No: "Нет",
  l_Keyword: "Ключевое слово",
  l_Search: "Поиск",
  l_Active: "Активный",
  l_Deleted: "Удалён",
  l_Include_deleted: "Включая удалённых",
  l_Initial: "Начальный",
  l_Final: "Последний",
  l_NotFound: "Не найден",
  l_Succeed: "Операция прошла успешно",
  l_Segment_name: "Название сегмента",
  l_Segment_priority: "Приоритет сегмента",
  l_Color: "Цвет",
  l_By_default: "По умолчанию",
  l_Yellow: "Желтый",
  l_Green: "Зеленый",
  l_Grey: "Серый",
  l_Red: "Красный",
  l_Orange: "Оранжевый",
  l_Status_name: "Название статуса",
  l_Priority: "Очередность",
  l_Status_type: "Тип статуса",
  l_Complete_order: "Завершить заказ",
  l_Complete_order_confirm:
    "Завершить заказ? Клиенту станут доступны подтверждение получения груза и оценка качества услуг.",
  l_Text_colour: "Цвет шрифта",
  l_Background_colour: "Цвет фона",
  l_After_setting_status: "После установки статуса",
  l_Message_for_seller: "Сообщение для продавца",
  l_Topic_of_the_message_for_seller_TWIG: "Тема сообщения для продавца TWIG",
  l_Name_2: "Наименование",
  l_Railway_station: "ЖД станция",
  l_Code: "Код",
  l_Railway: "Железная дорога",
  l_Railway2: "Железнодорожный транспорт",
  l_Rate: "Тариф",
  l_Legal_name: "Официальное имя",
  l_VAT_law: "Закон НДС",
  l_third_party_code: "Сторонний код",
  l___CountVat: "Тариф не используется в подсчете НДС",
  l_Default_VAT_rate: "Тариф НДС по умолчанию",
  l_Error: "Ошибка",
  l_Status_requires_calculation:
    "Вы можете изменить на этот статус только после создания расчёта!",
  l_Basic_information: "Основная информация",
  l_Custom_data: "Таможня разгрузки",
  l_Reloading_place: "Место перегрузки",
  l_ContactInfo: "Контактная информация",
  l_Signatures: "Изображения для документов",
  l_Directors_full_name: "ФИО руководителя",
  l_In_the_name_of_whom: "В лице кого",
  l_Expense_templates: "Шаблоны расходов",
  l_Custom_loading_data: "Таможня загрузки",
  l_Reloading_date: "Дата перегрузки",
  l_Post: "Должность",
  l_VAT_rate: "Тариф НДС",
  l_RRC: "КПП",
  l_OGRN: "ОГРН",
  l_Loading_place_custom: "Таможня загрузки",
  l_Size: "Размер",
  l_Is_general: "Основной статус",
  l_You_dont_have_permission: "У вас нету доступа на это действие",
  l_Is_automating_sending: "Автоматом отправляется",
  l_Pricing_type: "Тип расчета цены",
  l_Contact_information: "Контактная информация",
  l_Form_contains_errors: "Форма содержит ошибки",
  l_Country: "Страна",
  l_Price_show: "Ценник",
  l_City: "Город",
  l_There_is_nothing: "Никаких уведомлений",
  l_Correspondent_information: "Correspondent information",
  l_Telephone: "Телефон",
  l_Fax: "Факс",
  l_Email: "Эл.почта",
  l_Email_text: "Текст письма",
  l_Website: "Сайт",
  l_Main_company: "Основная компания",
  l_Operating_account: "Расчетный счет",
  l_Bank_code: "Код банка",
  l_Bank: "Банк",
  l_Different_invoices_for_different_currencies:
    "Разные счета для разных валют",
  l_Currency: "Валюта",
  l_Correspondent_bank: "Банк корреспондент",
  l_Print: "Печать",
  l_Company_logotype: "Логотип компании",
  l_Signature: "Подпись",
  l_correspondent_account: "К/с",
  l_Inc_VAT_price: "Цена с НДС",
  l_Ex_VAT_price: "Цена без НДС",
  l_Bank_name: "Название банка",
  l_Click_or_drag_ile_to_this_area_to_upload:
    "Нажмите или перетащите файл в эту область, чтобы загрузить",
  l_Department_name: "Название отдела",
  l_Department_prefix: "Префикс отдела",
  l_Company: "Компания",
  l_Login_email: "Логин Эл.почта",
  l_Groups: "Группы",
  l_Name_Surname: "Имя, фамилия",
  l_Surname: "Фамилия",
  l_Date_of_last_visit: "Дата последнего посещения",
  l_Mail_settings: "Настройки почты",
  l_Password: "Пароль",
  l_Reset_your_password: "Вы уверены, что хотите сбросить пароль?",
  l_For_bonus: "% для бонуса, %",
  l_Employee_prefix: "Префикс сотрудника",
  l_Department: "Отдел",
  l_Access_rights: "Права доступа",
  l_All: "Все",
  l_YourOwnDepartment: "Ваш отдел",
  l_YourOwn: "Только свой",
  l_Unlimited_access: "Неограниченный доступ",
  l_Additional_information: "Дополнительная информация",
  l_Main: "Основное",
  l_Access: "Доступ",
  l_Special_rights: "Спец. права",
  l_Group: "Группа",
  l_Numeration: "Нумерации",
  l_Numeration_name: "Название нумерации",
  l_Numeration_for: "Нумерация",
  l_Employee: "Сотрудник",
  l_Prefix: "Префикс",
  l_Year: "Год",
  l_Month: "Месяц",
  l_Delimiter: "Разделитель",
  l_Number_of_digits: "Кол-во цифр",
  l_Index: "Индекс",
  l_Suffix: "Суффикс",
  l_View: "Просмотр",
  l_Client: "Клиент",
  l_Consolidation: "Консолидация",
  l_Status_characteristic: "Характеристика статуса",
  l_Cargos: "Грузы",
  l_TNVED_code: "Код ТНВЭД",
  l_Transport_count: "Кол-во транспорта",
  l_Transit_date: "Дата транзита",
  l_Dimensions: "Габариты (Д×Ш×В)",
  l_Number_of_places: "Кол-во мест",
  l_No_cargo: "Грузы не добавлены",
  l_Copy_all: "Копировать всё",
  l_Copied: "Скопировано",
  l_Copy_failed: "Не удалось скопировать",
  l_Screenshot: "Скриншот",
  l_Screenshot_copied: "Скриншот скопирован",
  l_Screenshot_saved: "Скриншот сохранён",
  l_Screenshot_failed: "Не удалось сделать скриншот",
  l_Trips: "Рейсы",
  l_Cargos_status: "Статус грузов",
  l_Salary_calculation: "Расч. зарплаты",
  l_Show_filters: "Показать фильтры",
  l_New_status: "Новый статус",
  l_Car_trip: "Авто рейс",
  l_Order_date: "Дата заказа",
  l_Status_changed_at: "Дата изменения статуса",
  l_Date: "Дата",
  l_Users: "Пользователи",
  l_Documents: "Документы",
  l_Transport: "Транспорт",
  l_Other: "Другое",
  l_Sort: "Сортировка",
  l_Order_number: "Нр. заказа",
  l_Cargos_and_routes: "Грузы и маршруты",
  l_Order_status: "Статус заказа",
  l_New_trip: "Новый рейс",
  l_Loading_area: "Место загрузки",
  l_Unloading_area: "Место разгрузки",
  l_Loading_date: "Дата загрузки",
  l_Days_of_trip: "Дней в пути",
  l_Wagon_number: "Номер вагона",
  l_Car_number: "Номер машины",
  l_Invoice_number: "Номер счета",
  l_Invoice_issued: "Счет выписан",
  l_Pay_until: "Оплатить до",
  l_History_payment: "История платежей",
  l_Received: "Дата платежа",
  l_Price_without_VAT: "Сумма без НДС",
  l_Balance_of_payments: "Баланс платежей",
  l_Payment_balance: "Остаток платежей",
  l_New_payment: "Новый платеж",
  l_Payment_type: "Тип платежа",
  l_Cash: "Наличный расчет",
  l_Refusal_comment: "Причины отказа от запроса",
  l_Cashless: "Безналичный",
  l_Comment_type: "Тип комментарии",
  l_Cargo_price: "Стоимость груза",
  l_Payment_date: "Дата платежа",
  l_Payment_amount: "Оплаченная сумма",
  l_Template_section: "Шаблоны",
  l_Freight: "Фрахт",
  l_Copying: "Копирование",
  l_Apply: "Применить",
  l_Add_line: "Добавить линию",
  l_Price_with_V: "Цена с НДС",
  l_Receiver: "Принял платеж",
  l_Costs: "Расходы",
  l_Profit: "Прибыль",
  l_Packing_type: "Тип упаковки",
  l_Container: "Контейнер",
  l_Container_type: "Тип контейнера",
  l_Container_quantity: "Кол-во контейнеров",
  l_Container_ownership: "Принадлежность контейнера",
  l_Loading_by_carrier: "Загрузка перевозчиком",
  l_Calculation_data: "Данные для расчёта",
  l_Category: "Категория",
  l_Full_conditions: "Полные условия",
  l_Create_in_series: "Создать в серии",
  l_Series: "Серия",
  l_Cargo_properties: "Свойства груза",
  l_Stackable: "Штабелируемый",
  l_Regular_shape: "Правильная форма",
  l_Fragile: "Хрупкий",
  l_Must_be_upright: "Только вертикально",
  l_Magnetic: "Магнитный",
  l_Liquid: "Жидкость",
  l_Powder: "Порошок",
  l_Contains_battery: "Содержит батарею",
  l_Battery_type: "Тип батареи",
  l_Max_stack_weight: "Макс. вес штабелирования",
  l_Quantity: "Количество",
  l_User: "Пользователь",
  l_Trip_number: "Нр. рейса",
  l_Weight: "Вес",
  l_Donnot_count_in_balance: "Не учитывать расход в финансах",
  l_Seperate_line_in_the_invoice: "Отдельная строка в счет",
  l_Income: "Доход",
  l_Volume: "Объем (м3)",
  l_Total_freight: "Общий фрахт",
  l_Template_group: "Группы документов",
  l_Add_template: "Новый документ",
  l_Document_templates_group: "Группа шаблонов документа",
  l_Change_status: "Изменить статус",
  l_XML_unloading: "XML выгрузка",
  l_Managers: "Менеджеры",
  l_Date_of_creation: "Дата создания",
  l_Client_type: "Тип клиента",
  l_TIN_taxpayer_ID_number_VAT: "УНН/ЕГРПОУ/VAT№",
  l_Activity_area: "Вид деятельности",
  l_OKPO: "ОКПО",
  l_TIN: "ИНН",
  l_BIN: "БИН",
  l_TRN: "РНН",
  l_RNN: "РНН",
  l_INN: "ИНН",
  l_KPP: "КПП",
  l_IIN: "ИИН",
  l_Legal_address: "Юридический адрес ",
  l_Postal_address: "Почтовый адрес ",
  l_Payment_rules: "Правила оплаты",
  l_Credit_limit: "Кредитный лимит",
  l_Payment_delay: "Отсрочка платежа",
  l_Limit_exceeded: "Превышeниe лимитa",
  l_Deferred_payment_terms: "Усл. отсрочки платежей",
  l_Email_to_send_documents: "Эл. почта для отправки документов",
  l_Send_debt_remindings: "Отправлять напоминания о долгах",
  l_Swift: "Swift",
  l_PleaseEnterName: "Пожалуйста, введите имя",
  l_Contact_persons_posts: "Должность контакного лица",
  l_Contact_person: "Контактное лицо",
  l_Manager: "Менеджер",
  l_Days_from_the_latest_contract: "Дней от последнего контакта",
  l_Order_quantity: "Кол. заказов",
  l_Purchase_funnel: "Воронка продаж",
  l_Purchase_funnel_status: "Статус воронки продаж",
  l_Phone: "Телефон",
  l_Creation_date: "Дата создания",
  l_Type_of_the_received_document: "Вид полученного документа",
  l_Contact_personnel: "Контактные лица",
  l_Company_details: "Реквизиты компании",
  l_Active_requests: "Активные запросы",
  l_Archive_requests: "Архивные запросы",
  l_Archive: "Архивировать",
  l_Duly_represtnted: "В лице ..., На основании ...",
  l_Use_in_all_documents: "Использовать во всех документах",
  l_Phone_number: "Номер телефона",
  l_Skype: "Skype",
  l_ICQ: "ICQ",
  l_Comments: "Комментарии",
  l_PasswordNotLessThan6Letters: "Пароль должен содержать не менее 6 символов",
  l_Existed: "Существовал",
  l_EmailExisted: "Такой e-mail уже существует",
  l_Clients_order_number: "Номер заказа у клиента",
  l_Contacts: "Контакты",
  l_Default_forwarder: "Координатор",
  l_Additional_managers: "Freight coordinator",
  l_Price: "Цена",
  l_Price_with_VAT: "Начальная ставка с НДС",
  l_Deferred_payment_days: "Отсрочка платежа (дней)",
  l_Deferred_payment_conditions: "Условия отсрочки платежей",
  l_Full_text: "Полный текст",
  l_One_or_more_content_missing:
    "Один или несколько элементов контента отсутствуют",
  l_Statuses: "Статусы",
  l_Invoices: "Счета",
  l_Tasks: "Задачи",
  l_Number: "Нр.",
  l_Initial_freight: "Начальная ставка для клиента",
  l_Expenses: "Расходы",
  l_Forwarders: "Операторы",
  l_Documents_with_clients: "Документы с клиентом",
  l_Cargo_number: "Номер груза",
  l_Cargo_name: "Название груза",
  l_Cargo_parameters: "Параметры груза",
  l_Loading: "Погрузка",
  l_Access_to_req: "Доступ к запросам",
  l_Reloading_storage_place: "Место перезагрузки",
  l_Date_of_transhipment: "Дата перегрузки",
  l_Unloading: "Место разгрузки",
  l_Consignment_Price: "Стоимость груза",
  l_Loading_place: "Место загрузки",
  l_Time: "Время",
  l_Place_Company: "Место / Компания",
  l_Fullname: "Полное имя",
  l_Roles: "Роли",
  l_Work_time: "Время работы",
  l_Reset: "Сброс",
  l_Rate_date: "Дата курса",
  l_Contact_person_and_telephone: "Контактное лицо и телефон",
  l_Loading_place_customs: "Таможня загрузки",
  l_To: "До",
  l_New_company: "Новая компания",
  l_Delete: "Удалить",
  l_New_post: "",
  l_Unloading_place: "Место разгрузки",
  l_Unloading_place_customs: "Таможня разгрузки",
  l_Packing_type_quantity: "Тип упоковки/количество",
  l_Pallets: "Паллеты",
  l_Workers_post: "Должность сотрудников",
  l_Logs: "Логи",
  l_Session_log: "Журнал действий",
  l_LDM: "LDM (м)",
  l_Length: "Длина (м)",
  l_Different_acc_for_currency: "Разные счета для разных валют",
  l_Width: "Ширина (м)",
  l_Height: "Высота (м)",
  l_Document_is_sending: "Отправка документа",
  l_Sender: "Отправитель",
  l_Theme: "Тема",
  l_Send: "Отправить",
  l_Copy: "Копировать",
  l_Partial_cargo: "Неполный груз",
  l_Cargo_additional_information: "Дополнительная информация о грузе",
  l_Attributes: "Атрибуты",
  l_Insurance: "Страховка",
  l_More: "Подробнее",
  l_Less: "Скрыть",
  l_Successed: "Успешно выполнено",
  l_Terms_of_delivery: "Условия поставки (по Инкотермс 2010)",
  l_Transit_Time: "Транзитное время",
  l_Status: "Статус",
  l_Unloading_date: "Дата разгрузки",
  l_Carrier: "Перевозчик",
  l_Trip_or_cargo_number: "Нр. рейса / груза",
  l_Forwarder: "Оператор",
  l_Received_invoices: "Полученные счета",
  l_Cargos_and_Routes: "Грузы и Маршруты",
  l_Carrier_company: "Компания перевозчик",
  l_Carrier_contract_number_with_carrier: "Номер договора с перевозчиком",
  l_Insurance_policy_valid_until: "Срок действия страховки до",
  l_Number_in_carriers_system: "Номер в системе перевозчика",
  l_Trip: "Рейс",
  l_Terms_and_conditions_of_payment: "Срок и условия оплаты",
  l_Vehicle_number: "Номер тр. средства",
  l_Trailers_numbers: "Номера прицепа",
  l_Transport_type: "Тип транспорта",
  l_Loading_method: "Способ погрузки",
  l_Passport_number: "Номер паспорта",
  l_Driver: "Водитель",
  l_Container_number: "Номер контейнера",
  l_Sizes_L_W_H: "Габариты (Д*Ш*В)",
  l_Notification: "Уведомления",
  l_Amount: "Количество",
  l_Packing: "Упаковка",
  l_Order: "Заказ",
  l_Order_code_referral: "Реферальный код",
  l_Order_code_referral_short: "Реф. код",
  l_Signing_condition: "Условие подписания",
  l_Invoice_received: "Полученные счета",
  l_Invoicess_issued: "Выписанные счета",
  l_Route: "Маршрут",
  l_Trip_expenses: "Расходы рейса",
  l_Car_trips_expenses: "Расходы авто рейсов",
  l_Rail_trips_expenses: "Расходы ЖД рейсов",
  l_Finance_operations: "Финансовые операции",
  l_Cargo_status: "Статус груза",
  l_Received_invoice: "Полученный счет",
  l_Expense: "Расход",
  l_Expenses_incl_VAT: "Расход с НДС",
  l_Dont_count_in_balance: "Не учитывать расход в финансах",
  l_Separate_line_in_the_invoice: "Отдельная строка в счёт",
  l_Expense_description: "Описание расходов",
  l_Document_name: "Название документа",
  l_Document_expiration_date: "Срок действия документа",
  l_Available_for_client: "Доступно для клиента",
  l_Show_to_client: "Показать клиенту",
  l_Type: "Тип",
  l_Template: "Шаблон документа",
  l_Attached_file: "Прикрепленый файл",
  l_Document_number: "Номер документа",
  l_Document_date: "Дата документа",
  l_Provide_access_to_the_client: "Предоставить доступ клиенту",
  l_File: "Файл",
  l_OverheadDocuments: "Накладные",
  l_Tags: "Теги",
  l_Rail_trips: "Железнодорожные рейсы",
  l_OtherDocuments: "Другие документы",
  l_Acts: "Акты",
  l_Photos: "Фотографии",
  l_Link: "Ссылка",
  l_To_comment: "Комментировать",
  l_Comment: "Комментарий",
  l_Cargo: "Груз",
  l_Place: "Место",
  l_ETA: "ETA",
  // l_Session_log:"Журнал действий",
  l_Data: "Данные",
  l_ID_session: "ID сессий",
  l_Brouser: "Браузер",
  l_Sent: "Отправлено",
  l_Author: "Автор",
  l_Trip_type: "Тип статуса",
  l_Neutral: "Нейтральный",
  l_Finish: "Конечный",
  l_Change_the_status_of_cargo_on_this_flight:
    "Изменить статус грузов в этом рейсе",
  l_Are_you_sure_you_want_to_update: "Вы уверены, что хотите обновить?",
  l_Finance_template: "Финансовый шаблон",
  l_Wagon_data: "Данные вагона",
  l_Train_Trip_number: "Номер поезда/рейса",
  l_Car_Container_number: "Номер вагона/контейнера",
  l_Cargo_data: "Данные груза",
  l_GNG_code: "ГНГ код",
  l_Classes_of_transport_rates: "ЕТСНГ",
  l_Rules_for_using_the_car: "Правила использования машины",
  l_Wagon_renter: "Арендатор вагона",
  l_Freight_with_VAT: "Фрахт с НДС",
  l_Login_: "Авторизоваться",
  l_Close: "Закрывать",
  l_Directions: "Направления",
  l_Full_name: "Полное имя",
  l_From: "Из",
  l_From_request: "Из запроса",
  l_Countries: "Страны",
  l_Drivers_name: "Имя водителя",
  l_Drivers_surname: "Фамилия водителя",
  l_Middle_name: "Отчество водителя",
  l_Passport: "Паспорт",
  l_Driving_licence_number: "Серия и номер вод. прав",
  l_Driving_licence_categories: "Категории вод. прав",
  l_Fuel_card: "Топливная карта",
  l_Organization_section: "Раздел организации",
  l_Is_active: "Работает",
  l_Permission_settings: "Настройки прав доступа",
  l_New_user: "Новый пользователь",
  l_Bank_account: "Номер счета",
  l_Contact_type: "Тип контакта",
  l_Vehicle: "Грузовой транспорт",
  l_Specifications: "Технические характеристики",
  l_Group_of_employees: "Группы сотрудников",
  l_updateStatus: "Обновить состояние",
  l_Group_name: "Название группы",
  l_Date_of_employment: "Дата приема на работу",
  l_Euro_emission_class: "Экологический класс",
  l_Trailer_number: "Номер прицепа",
  l_Brand: "Марка",
  l_Empty: "Пусто",
  l_No_data: "Нет данных",
  l_Contract_for_trips: "Договор для рейса",
  l_Without_stamp_and_sign: "Без печатей и подписей",
  l_Have_expiration_date: "Срок действия документа",
  l_Model: "Модель",
  l_Production_date: "Дата производства",
  l_Body_number: "Номер кузова",
  l_Registration_date: "Дата регистрации",
  l_Tech_passport_validity: "Срок действия Тех. Паспорта",
  l_License_number: "Номер лицензии",
  l_License_validity_date: "Срок действия лицензии",
  l_Drivers: "Тип транспорта",
  l_Transport_information: "Данные транспорта",
  l_Vehicle_empty_weight: "Собственная масса",
  l_Auto_pick_up: "Автозабор",
  l_Created: "Время создания",
  l_Updated: "Время изменения",
  l_Exprired: "Срок действия документа",
  l_Element_rule_list: "	Список элементов правила",
  l_Position_of_contacts: "Позиции контактных людей",
  l_Adding: "Добавление",
  l_Sorting: "Сортировка",
  l_Name_of_the_kind_of_packing: "Наименование вида упаковки",
  l_Request_source: "Источник получения запроса",
  l_Classifier: "Справочники",
  l_Vehicle_full_weight: "Полная масса",
  l_Vehicle_axels: "Кол-во осей",
  l_Vat_rate: "Тариф НДС",
  l_Order_detail: "Детали заказа",
  l_Total_received_invoice: "Всего получено счетов:",
  l_Expences: "Расходы",
  l_Carrier_types: "Тип перевозчика",
  l_Received_payment: "Полученные платежи",
  l_Margin: "Маржа",
  l_New_request_purpose: "Новый цель запроса",
  l_Order_status_id: "Статус заказа",
  l_Type_of_transport: "Вид перевозки",
  l_New_carrier: "Новый перевозчик",
  l_Reply_deadline: "Ответ предоставить до даты",
  l_Cargo_ready_date: "Дата готовности груза",
  l_List_empty: "Список пуст",
  l_Total_issued_invoice: "Всего выписано счетов",
  l_Are_you_sure_to_confirm: "Вы уверены, что хотите подтвердить этот запрос?",
  l_Term: "Условие отсрочки платежей",
  l_Save: "Сохранить",
  l_Choose_client: "Выберите клиента",
  l_Add_service: "Новая услуга",
  l_Contact_partner: "Контактное лицо",
  l_New_contact_person: "Новое контактное лицо",
  l_New_payment_term: "Новое условие платежей",
  l_Deferred_payment_condition: "Условия отсрочки платежей",
  l_Max_weight: "Мах. Вес нагрузки",
  l_Max_euro_pallets: "Мах. кол-во евро-палет",
  l_External_trip: "Внешний рейс",
  l_Relevant_documents: "Необходимые документы",
  l_Add_cargo: "Добавить груз",
  l_Expence: "Расход",
  l_Payment_term: "Усл. отсрочки платежей",
  l_Click_or_drag_file_to_this_area_to_upload: "",
  l_Seller: "Продавец",
  //l_Total_received_invoice:"Всего получено счетов",
  l_Destination: "Отправление",
  l_Destination_time: "Время отправки",
  l_Departure: "Назначение",
  l_Departure_time: "Время доставки",
  l_Country_from: "Страна Из",
  l_Are_you_sure_to_cancel:
    "Вы уверены, что хотите изменить статус запроса на 'Неподтвержденный'?",
  l_Refusal_reason: "Причина отказа от запроса",
  l_Return_for_revision: "Возврат на доработку",
  l_Return_reason: "Причина возврата",
  l_Enter_return_reason: "Введите причину возврата",
  l_Return_reason_required: "Причина возврата обязательна",
  l_Country_to: "Страна В",
  l_Receiving_date: "Дата получения",
  l_City_from: "Город Из",
  l_third_part_price: "Сторонний код",
  l_City_to: "Город В",
  l_Confirm: "Подтвердить",
  l_New_bank: "Новый банк",
  l_Confirm_and_create: "Подтвердить и создать",
  l_Contract_partner: "Контактное лицо",
  l_Direction: "Направление",
  l_Delivery_date: "Время доставки",
  l_Company_required: "Укажите компанию",
  l_Total_weight: "Общий вес",
  l_Total_volume: "Общий объем",
  l_Delivery_terms: "Условия поставки (по Инко термс 2010)",
  l_Transit_time: "Транзитное время",
  l_Waybill_number: "RWB/AWB/CMR",
  l_Ttn_number: "ТТН номер",
  l_Vehicle_or_container_number: "Номер ТС / контейнера",
  l_Borders: "Границы",
  l_Number_in_carrier_system: "Номер в системе перевозчика",
  l_Price_proposals: "Ценовые предложения",
  l_Expence_without_VAT: "Сумма без НДС",
  l_Expence_with_VAT: "Расход с НДС",
  l_Bid_price: "Ставка",
  l_Bid_price_with_VAT: "Ставка с НДС",
  l_Request_date: "Дата запроса",
  l_Is_Partial_Cargo: "Неполный груз",
  l_Client_price: "Цена клиенту",
  l_Please_select_at_least_one_cargo: "Пожалуйста, выберите хотя бы один груз",
  l_Carrier_price: "Ставка перевозчика",
  l_Give_access_to_carrier: "Предоставить доступ перевозчику",
  l_Valid_from: "Действителен с",
  l_Notify_about_expiration: "Информоривать ",
  l_New_calculation: "Новый расчет",
  l_Valid_until: "Действителен до",
  l_Document_groups: "Группы документов",
  l_New_city: "Новый город",
  l_Template_name: "Название перевозки",
  l_Is_default: "По умолчанию",
  l_Service_type: "Вид перевозки",
  l_Cities: "Города",
  l_Position_of_contact_persons: "Позиции контактных людей",
  l_Packagings: "Упаковки",
  l_Statistical: "Статистический",
  l_Statistic: "Статистика",
  l_Unregistered: "Незарегистрированный",
  l_Role: "Управление",
  l_New_client: "Новый клиент",
  l_Product: "Продукт",
  l_The_reason_of_refusal: "Причина отказа от запроса",
  l_Request_sources: "Источник получения запроса",
  l_Request_purposes: "Цели запроса",
  l_Request_status: "Статус запросы",
  l_Permission: "Разрешение",
  l_Request_statuses: "Статусы запросы",
  l_Description: "Описание",
  l_Services: "Услуги",
  l_Peromission_key: "Ключ разрешения",
  l_Parent_option: "Родительский параметр",
  l_Level: "Уровень",
  l_Postal_code: "Почтовый индекс",
  l_Additional_info: "Дополнительная информация",
  l_Auto_pickup: "Автозабор",
  l_Logistician: "Логист",
  l_Extremely_urgent: "Чрезвычайно срочно",
  l_Product_type: "Тип продукта",
  l_Request_is_received: "Запрос принят?",
  l_Border_point: "Пограничный переход",
  l_Cost_per_cargo: "Разбить данный расход по связанным заказам",
  l_By_weight: "По весу",
  l_By_volume: "По объему",
  l_By_weight_and_volume: "По весу и объему",
  l_Batch_setting_cargo_status: "Пакетная установка статуса груза",
  l_Select: "Выберите",
  l_Selected: "Выбрано",
  l_not_selected: "Не выбрано",
  l_Distribute_percent: "Процент распределения",
  l_Distribute_price: "Цена распределения",
  l_Total: "Всего",
  l_Clear: "Очистить",
  l_Request_purpose: "Цель запросы",
  l_Request_number: "Номер запроса",
  l_By: "По",
  l_Add_date: "Добавить дату",
  l_Update_date: "Дата обновления",
  l_Descending: "По убыванию",
  l_Ascending: "По возрастанию",
  l_Invoice: "Счет",
  l_Invoices_issued: "Выписанные счета",
  l_invoiceNumber: "Номер счета",
  l_Change_order_status: "Изменить статус заказа",
  l_senderInvoice: "Компания",
  l_issuedDate: "Счет выписан",
  l_receivingDate: "Дата получения",
  l_payUntilDate: "Оплатить до",
  l_Trip_status: "Статус рейса",
  l_Without_VAT: "без НДС",
  l_With_VAT: "с НДС",
  l_Invoice_line: "Строка счета",
  l_Unit: "Ед.",
  l_Received_from: "Получен от",
  l_Company_which_received_the_invoice: "Компания которая получила счет",
  l_Breaking_rule: "Правило разбивки",
  l_Contractor: "Исполнитель",
  l_Payer: "Плательщик",
  l_Language: "Язык",
  l_Made: "Составил",
  l_Notes: "Примечания",
  l_Devider: "Делитель",
  l_Element: "Элемент",
  l_Percent: "Процент",
  l_INN_EGRPOU_VAT_BIN_UNN: "ИНН, ЕГРПОУ, VAT, БИН, УНН",
  l_Start: "Старт",
  l_End: "Конец",
  l_Contract_date: "Дата контракта",
  l_Contract_number: "Номер договора с клиентом",
  l_Has_contract: "Есть договор",
  l_Contragents: "Контрагенты",
  l_Rail_trip: "Железнодорожные рейсы",
  l_Issued_invoice_in_order: "Выставленный счёт в заказе",
  l_Status_history: "История статусов",
  l_New_request: "Новый запрос",
  l_Notification_language: "Язык уведомлений",
  l_Classifier_section: "Раздел справочников",
  l_Images_for_docs: "Изображения для документов",
  l_Director: "ФИО руководителя",
  l_Representive_name: "В лице кого",
  l_Worker_post: "Должность",
  l_Company_prefix: "Префикс компании",
  l_Stamp: "Stamp",
  l_Logo: "Logo",
  l_Sign: "Sign",
  l_New_cargo: "Новый груз",
  l_New_country: "Новая страна",
  l_Default_country: "Страна по умолчанию",
  l_European_country: "Европейская страна",
  l_Postponement_days: "Дни отсрочки",
  l_Is_Use_nonstandard_invoice_template:
    "Использовать нестандартный шаблон счета",
  l_Is_without_StampAnd_Signature: "Без печатей и подписей",
  l_Visible_for_client: "Виден клиенту",
  l_Received_date: "Счет выписан",
  l_Trailers_number: "Номер прицепа",
  l_Client_type_definition:
    "Типы клиентов - классификация Клиентов по важности/срочности.Заполняется в карточке Клиента и взаимодействует с Запросами. При заполнении справочника можно установить приоритет сегмента. Эта цифра определяет важность и позицию Запроса от клиента с данным Типом. Работает так: добавляем в справочник Тип клиента VIP, приоритет сегмента - 1. Далее в карточке нужного Клиента выбираем данный тип и все запросы от данного Клиента будут расположены в самом верху общей таблицы Запросов независимо от того, в каком порядке они поступили. Также в блоке Клиенты можно использовать фильтр, чтобы сделать выборку по Клиентам определенного Типа.",
  l_Trip_number_must_be_unique: "Рейс с таким номером уже существует",
  l_Company_is_required: "Выберите компанию",
  l_File_is_required: "Загрузите файлы",
  l_Comment_is_required: "Заполните комментарий",
  l_Contract_is_required: "Выберите нр. рейса",
  l_Document_name_is_required: "Введите название документа",
  l_Company_name_is_required: "Введите название компании",
  l_Expense_name_required_without_template:
    "Название обязательно, если шаблон не выбран",
  l_Business_number_is_required: "Введите номер",
  l_Required_field: "Обязательное поле",
  l_Select_required: "Выберите значение",
  l_Type_to_search_orders: "Введите заказ для поиска",
  l_Transfer_client: "Перебросить клиента",
  l_Transfer: "Перебросить",
  l_Transfer_history: "История переброски",
  l_New_manager: "Новый менеджер",
  l_From_manager: "От менеджера",
  l_To_manager: "К менеджеру",
  l_Performed_by: "Выполнил",
  l_Selected_clients: "Выбрано клиентов",
  l_Refresh: "Обновить",
  l_System_break: "Системный перерыв",
  l_Active_break: "Активный перерыв",
  l_No_active_break: "Нет активного перерыва",
  l_Break_reason: "Причина перерыва",
  l_Break_reason_placeholder: "Напр.: Обеденный перерыв",
  l_Break_reason_required: "Укажите причину перерыва",
  l_Break_from: "Начало",
  l_Break_to: "Конец",
  l_Break_time_required: "Укажите время начала и конца перерыва",
  l_Break_started_by: "Запущен пользователем",
  l_Add_break: "Добавить перерыв",
  l_Start_break: "Начать перерыв",
  l_Stop_break: "Завершить перерыв",
  l_Stop_break_confirm: "Вы уверены, что хотите завершить перерыв досрочно?",
  l_System_on_break: "Система на перерыве",
  l_Break_ends_at: "Перерыв до",
  l_Break_history: "История перерывов",
  l_Finished: "Завершён",
  l_Generate_sno: "Сформировать СНО",
  l_Create: "Создать",
  l_General_invoice: "Общий счёт",
  l_Create_general_invoice: "Сформировать общий счёт",
  l_General_invoice_created: "Общий счёт создан",
  l_General_invoice_create_error: "Не удалось создать общий счёт",
  l_Download_avr: "Скачать АВР",
  l_Download_realization: "Скачать реализацию",
  l_OneC_document_not_ready: "1С ещё не прислала документ",
  l_Split_into_tranches: "Разбить на транши оплаты",
  l_First_tranche: "Первый транш, %",
  l_Second_tranche: "Второй транш, %",
  l_Rate_source: "Источник курса USD",
  l_Nbrk_rate: "Курс НБ РК",
  l_Forte_rate: "Форте",
  l_Manual_rate: "Ручной курс",
  l_Sno_auto_updated: "Автообновлён",
  l_Paid_by_1c: "Оплачено по данным 1С",
  l_From_date: "от",
  l_Document: "документ",
  l_Rate_source_change_hint:
    "Счёт будет пересчитан по курсу выбранного источника и переотправлен в 1С. Если по счёту уже есть оплата — смена невозможна.",
  l_Rate_source_change_separately:
    "Смена источника курса — отдельное действие: сохраните остальные правки, затем поменяйте источник курса в списке счетов.",
  l_Approve: "Одобрить",
  l_Download_xlsx: "Скачать XLSX",
  l_Download_pdf: "Скачать PDF",
  l_Manual_exchange_rates: "Ручные курсы USD",
  l_Usd_kzt_rate: "Курс тенге к доллару (KZT/USD)",
  l_Rate_kzt_per_usd: "Курс, ₸ за 1 $",
  l_Add_rate: "Добавить курс",
  l_File_not_ready: "Файл счёта пока не готов, попробуйте позже",
  l_Specify_both_tranches: "Укажите процент для обоих траншей",
  l_Select_payer: "Выберите плательщика",
  l_Select_vat_rate: "Выберите ставку НДС",
  l_Add_at_least_one_line: "Добавьте хотя бы одну строку счёта",
  l_Fill_line_description: "Заполните описание во всех строках счёта",
  l_Invalid_line_amount: "Укажите корректное количество в строках счёта",
  l_Invalid_line_price: "Укажите корректную цену в строках счёта",
  l_Status_requires_review: "Требует проверки",
  l_Status_approved: "Одобрен",
  l_Status_sent_to_1c: "Отправлен в 1С",
  l_Status_sent_to_client: "Отправлен клиенту",
  l_Status_completed_by_1c: "Обработан в 1С",
  l_Status_awaiting_payment: "Ожидает оплаты",
  l_Status_partially_paid: "Оплачен частично",
  l_Status_paid: "Оплачен",
  l_Status_realized: "Реализован",
  l_Status_error_from_1c: "Ошибка 1С",
  l_Status_resent_to_1c: "Повторно отправлен в 1С",
  l_Resubmit_sno_note: "Будет отправлен тот же СНО с обновлёнными данными плательщика из карточки клиента. Изменённые суммы и строки не отправятся.",
  l_Sno_already_sent_to_1c: "СНО уже отправлен в 1С",
  l_Sno_not_sent_to_1c_yet: "СНО ещё не отправлен в 1С — сначала согласуйте его",
  l_OneC_error_contract_hint: "Бухгалтер должен завести договор в этой валюте в 1С, либо смените валюту СНО на KZT",
  l_OneC_error_bin_not_found: "БИН плательщика не найден в 1С",
  l_OneC_error_required_field_missing: "Не заполнено обязательное поле",
  l_OneC_error_invalid_template: "Некорректный шаблон СНО",
  l_OneC_error_document_not_found: "Документ не найден в 1С",
  l_OneC_error_document_update_error: "Ошибка обновления документа в 1С",
  l_OneC_error_internal: "Внутренняя ошибка 1С",
  l_OneC_error_bin_hint: "Проверьте БИН в карточке клиента (12 цифр) и отправьте СНО повторно",
  l_Open_payer_card: "Карточка плательщика",
  l_Field: "Поле",
  l_Resubmit_sno: "Отправить в 1С повторно",
  l_Version: "Версия",
  l_Sno_history: "История СНО",
  l_Version_actual: "Актуальная",
  l_Version_replace_reason: "Причина замены",
  l_New_version_warning:
    "После изменения будет создана новая версия документа. Предыдущая версия останется в истории.",
  l_Sno_not_formed: "СНО ещё не сформирован — изменение недоступно",
  l_Avr: "АВР",
  l_Generate_avr: "Сформировать АВР",
  l_Avr_required: "Требуется АВР",
  l_Avr_type: "Тип АВР",
  l_Avr_electronic: "Электронный",
  l_Avr_paper: "Бумажный",
  l_Avr_status_not_requested: "Не запрошен",
  l_Avr_status_requested: "Запрошен",
  l_Avr_status_in_progress: "В работе",
  l_Avr_status_formed: "Сформирован",
  l_Avr_status_error: "Ошибка",
  l_Open: "Открыть",
  l_Download: "Скачать",
  l_Client_bin: "БИН клиента",
  l_Already_formed: "Уже сформирован",
  l_Select_all: "Выбрать все",
  l_Deselect_all: "Снять все",
  l_All_electronic: "Всем «Электронный»",
  l_All_paper: "Всем «Бумажный»",
  l_Avr_bulk_confirm:
    "Отправить бухгалтеру запрос на формирование АВР по выбранным заявкам ({n})?",
  l_Request_sent: "Запрос отправлен",
  l_Result: "Результат",
  l_Nothing_selected: "Не выбрано ни одной заявки",
  l_Updated_by: "Кем изменён",
  l_Updated_at: "Дата изменения",
  l_Tranche: "Транш",
  l_Save_as_template: "Сохранить как шаблон",
  l_Template_saved: "Шаблон сохранён",
  l_Delete_template_confirm: "Удалить шаблон?",
  l_Delete_invoice_confirm: "Удалить счёт?",
  l_Template_name_optional: "Название (необязательно)",
  l_Editing: "Редактирование",
  l_CN_operators: "Операторы",
  l_CN_operator: "Оператор",
  l_Freight_coordinators: "Freight coordinators",
  l_Freight_coordinator: "Freight coordinator",
  l_Logisticians: "Логисты",
  l_Manager_assignment_templates: "Шаблоны привязки менеджеров",
  l_Product_type_assignment_templates: "Шаблоны привязки типов продуктов",
  l_Already_assigned: "уже привязан",
  l_Product_type_already_assigned:
    "Типы продукта уже привязаны к другому шаблону: {items}",
  l_Exchange_rates: "Курсы валют",
  l_Forte_rates: "Курсы ForteBank",
  l_Rate_sell: "Курс продажи",
  l_Fetched_at: "Получено из Forte",
  l_Forte_rate_not_found: "Курс на выбранную дату не найден",
  l_Forte_rate_not_found_hint:
    "Курсы сохраняет ежедневная джоба примерно в 09:00, поэтому за будущие даты и за сегодняшний день до её запуска данных нет. Валюта CNY не собирается вовсе.",
  // Подтверждение документов заявки
  l_Approval_status: "Статус подтверждения",
  l_Doc_status_todo: "Не отправлен",
  l_Doc_status_review: "На проверке",
  l_Doc_status_approved: "Подтверждён",
  l_Doc_status_rejected: "Отклонён",
  l_Doc_status_uploaded_by_client: "Загрузил клиент",
  l_Doc_status_approved_by_client: "Подтвердил клиент",
  l_Confirm_document: "Подтвердить документ",
  l_Reject_document: "Отклонить документ",
  l_Rejection_reason: "Причина отказа",
  l_Enter_rejection_reason: "Например: не читается скан, пришлите заново",
  l_Rejection_reason_required: "Укажите причину отказа",
  // Запрос информации у клиента
  l_Request_info_from_client: "Запросить информацию у клиента",
  l_Info_requested_from_client: "Запрошена информация",
  l_Edit_info_request: "Изменить запрос информации",
  l_What_is_needed: "Что нужно от клиента",
  l_Info_request_comment_placeholder: "Например: нужно до расчёта ставки",
  l_Reminders: "Напоминания",
  l_Waiting_answer: "Ждём ответ",
  l_Closed: "Закрыт",
  l_Close_request: "Закрыть запрос",
  l_Are_you_sure_delete_info_request: "Удалить запрос информации?",
  l_Info_item_packing_list: "Упаковочный лист с числом коробов",
  l_Info_item_invoice: "Инвойс",
  l_Info_item_tnved_code: "Код ТН ВЭД",
  l_Info_item_cargo_photo: "Фото груза / паллет",
  l_Info_item_specification: "Спецификация по артикулам",
  l_Cadence_off: "Не напоминать",
  l_Cadence_6h: "Каждые 6 часов",
  l_Cadence_12h: "Каждые 12 часов",
  l_Cadence_24h: "Каждые 24 часа",
  l_Cadence_48h: "Каждые 48 часов",
  l_Cadence_72h: "Каждые 72 часа",
  l_Cadence_off_hint: "Напоминания клиенту отправляться не будут",
  // Сквозной список инфо-запросов
  l_Info_requests: "Запросы информации",
  l_Partially_answered: "Ответ частичный",
  l_Answered_at: "Ответ получен",
  l_Requested_by: "Запросил",
  l_Requested_at: "Запрошено",
  l_Client_answered: "Клиент ответил",
  l_Any: "Не важно",
  l_Preset_waiting_client: "Ждём ответ клиента",
  l_Preset_partially_answered: "Ответили частично",
  l_Preset_all_active: "Все активные",
  l_Info_request_pending_items: "Ждём от клиента",
  // Ответ клиента на ценовое предложение
  l_Client_response: "Ответ клиента",
  l_Client_accepted: "Принято",
  l_Client_declined: "Отклонено",
  l_Client_comment: "Комментарий клиента",
  l_No_answer_yet: "Нет ответа",
  l_Sales_plans: "Планы продаж",
  l_Plan_type: "Тип плана",
  l_Plan_type_KNR: "План КНР",
  l_Plan_type_EUROPE: "План Европа",
  l_Monthly_targets: "Помесячные цели",
  l_Yearly_target: "Годовая цель",
  l_Yearly_target_hint: "сумма помесячных целей, считается автоматически",
  l_Months_filled: "Месяцев заполнено",
  l_Scope: "Показывать",
  l_My_plans: "Мои планы",
  l_All_plans: "Все планы",
  l_Calls_count: "Количество звонков",
  // Документы заказа: согласование с клиентом (.todo/order-updates.md)
  l_Draft_type: "Тип драфта",
  l_Draft_type_cmr: "CMR",
  l_Draft_type_rwb: "RWB",
  l_Draft_type_awb: "AWB",
  l_Draft_type_declaration: "Экспортная декларация",
  l_Document_type: "Тип документа",
  l_Request_from_client: "Запросить у клиента",
  l_Request_reason: "Причина запроса (её видит клиент)",
  l_Template_for_client: "Шаблон для клиента",
  l_Save_and_send_to_client: "Сохранить и отправить клиенту",
  l_Send_to_client: "Отправить клиенту",
  l_Reupload_document: "Перезалить документ",
  l_Upload_own_version: "Загрузить свою версию",
  l_Waiting_for_client: "Ждём клиента",
  l_Your_turn: "Ваш ход",
  l_Send_again: "Отправить заново",
  l_Client_file: "Файл клиента",
  l_Replace_template: "Заменить шаблон",
  l_Template_client_hint: "Клиент увидит шаблон, приложит свой заполненный файл и вернёт его вам на согласование. Файл уходит клиенту как есть, в любом формате — PDF, DOCX, XLSX, скан.",
  l_Template_reupload_hint: "Новый файл заменит шаблон, файл клиента будет очищен, а ход вернётся клиенту.",
  l_Doc_error_pending_manager: "Документ уже на проверке",
  l_Doc_error_not_pending_manager:
    "Сейчас ход клиента — согласование недоступно",
  l_Doc_error_already_approved: "Документ согласован, изменения недоступны",
  l_Doc_error_file_required: "Приложите хотя бы один файл",
  l_Doc_error_not_found: "Документ не найден, список обновлён",
  l_Created_by_client: "Создал клиент",
  l_Created_by_client_hint: "Заявку завёл клиент в личном кабинете",
  l_Client_returned: "Клиент вернул",
  l_Catalog_technical_description: "Техническое описание",
  l_Catalog_intended_use: "Область применения",
  l_Catalog_declaration_conformity: "Декларация соответствия",
  l_Catalog_knb_approval: "Заключение КНБ",
  l_Catalog_rgi_approval: "Заключение РГИ",
  l_Catalog_miid_approval: "Заключение МИИР",
  l_Catalog_ses_exemption: "Отказное письмо от СЭС",
  l_Catalog_state_registration: "СГР",
  l_Catalog_registration_certificate: "РУ",
  l_Catalog_import_license: "Лицензия на импорт",
  l_Catalog_knb_notification: "Нотификация КНБ",
  l_Catalog_invoice: "Инвойс",
  l_Catalog_packing_list: "Упаковочный лист",
  l_Catalog_authenticity: "Достоверность",
  l_Catalog_other: "Другое",
  l_Request_document_from_client: "Запрос документа у клиента",
  l_Sure_send_to_client: "Отправить документ клиенту?",
  l_Sure_confirm_document: "Подтвердить документ клиента?",
  l_Responded_at: "Ответ клиента",
  // Обязательные документы клиента (.todo/mandatory-client-documents-fe.md)
  l_Mandatory_document: "Обязательный",
  l_Mandatory_document_hint:
    "Документ обязателен для клиента: удалять и менять тип нельзя",
  // Согласование цены (.todo/price-negotiation-api.md)
  l_Price_negotiation: "Согласование цены",
  l_No_price_negotiation: "Согласование цены ещё не начиналось",
  l_Calculation: "Расчёт",
  l_Client_decision_review: "На рассмотрении",
  l_Client_decision_accepted: "Клиент согласовал",
  l_Client_decision_declined: "Клиент отклонил",
  l_Client_proposals: "Встречные предложения клиента",
  l_Client_proposed_price: "Цена клиента",
  l_Offered_price: "Предложено менеджером",
  l_Agreed_price: "Согласованная цена",
  l_Status_code: "Код статуса",
  l_Feedback_reasons: "Причины оценки заказа",
  l_Positive: "Положительная",
  l_Negative: "Отрицательная",
  // Онбординг клиента: гайды по продуктам (.todo/client-onboarding.md)
  l_Product_guides: "Гайды по продуктам",
  l_Guide_text: "Текст гайда",
  l_Only_active: "Только активные",
  l_Guide_category_air: "Авиа",
  l_Guide_category_train: "Ж/Д",
  l_Guide_category_auto: "Авто",
  l_Guide_category_auto_eu: "Авто (ЕС)",
  l_Guide_category_kz_kz: "Внутренние (КЗ)",
  l_Requires_signature: "Договор на подписание",
  l_Awaiting_signature: "На подписании",
  l_Signed: "Подписан",
  l_Export_cooldown_hint:
    "Выгрузка уже запущена. Повторить можно через {n} сек.",
  // История версий документа (DocumentRevision): что грузили до текущей версии
  l_Document_history: "История версий документа",
  l_Uploaded_at: "Дата загрузки",
  l_Uploaded_by: "Кто загрузил",
  l_Calculation_accepted_by_client_locked:
    "Ценовое предложение согласовано клиентом и зафиксировано. Для изменения требуется повторное согласование с клиентом.",
  l_Shortfall_invoice: "Доп. счёт по недобору",
  l_Create_shortfall_invoice: "Выставить доп. счёт",
  l_Shortfall_invoice_created: "Доп. счёт создан",
  l_Shortfall_invoice_error: "Не удалось создать доп. счёт",
  l_Shortfall_invoice_source: "Недобор по счетам: {invoices}",
  l_Shortfall_invoice_source_unknown: "Недобор по оплаченным счетам",
  l_Shortfall_to_pay: "Остаток к оплате",
  l_Shortfall_amount: "Недобор по ставке (нужен доп. счёт)",
  l_Exchange_rate_source: "Источник курса",
  l_Exchange_rate_value: "Курс",
  l_Manual_rate_hint:
    "Тенге за 1 единицу выбранной валюты; пусто — курс из справочника",
  l_Manual_rate_hint_kzt:
    "Для СНО в тенге — курс валюты ставки заказа (тенге за 1 единицу); пусто — курс из справочника",
  l_Forte_only_usd_hint:
    "FORTE действует только для USD, для остальных валют — НБ РК",
  l_Invalid_manual_rate: "Курс должен быть больше нуля",
  l_Currency_and_rate: "Валюта и курс",
  l_Invoice_resend_1c_warning: "Счёт будет пересчитан и переотправлен в 1С",
  l_Close_avr: "Закрыть АВР",
  l_Close_avr_confirm: "Закрыть АВР по заказу?",
  l_Close_avr_bulk_confirm: "Закрыть АВР по выбранным заказам ({n})?",
  l_Avr_close_title: "Закрытие АВР",
  l_Avr_closed_info: "АВР закрыт {date}",
  l_Avr_close_success: "АВР закрыт",
  l_Avr_close_summary: "Закрыто: {closed}, пропущено: {skipped}",
  l_Avr_close_errors: "Ошибки:",
  l_Avr_close_no_permission: "Нет прав на закрытие АВР",
  l_Comments_all: "Все",
  l_Comments_with_client: "С клиентом",
  l_Comments_internal: "Внутренние",
  l_Comments_with_client_hint: "Клиент видит эти комментарии в личном кабинете",
  l_Comments_internal_hint: "Видны только сотрудникам — клиент их не видит",
  l_Comments_empty: "Комментариев пока нет",
  l_Comments_empty_with_client: "Клиенту пока ничего не написали",
  l_Comments_empty_internal: "Внутренних комментариев пока нет",
  l_Visible_to_client: "Видит клиент",
  l_Visible_to_carrier: "Видит перевозчик",
  l_Internal_comment: "Внутренний",
  l_Author_client: "Клиент",
  l_Author_carrier: "Перевозчик",
  l_Author_employee: "Сотрудник",
  l_Role_admin: "Админ",
  l_Role_manager: "Менеджер",
  l_Role_china_manager: "Менеджер Китай",
  l_Role_logist: "Логист",
  l_Role_product: "Продакт",
  l_Role_accountant: "Бухгалтер",
  l_Role_broker: "Брокер",
  l_You: "Вы",
};
